export const USED_AS_SPA = "false" === 'true';
export const SENTRY_DSN = "https://7e7e01496baa4a5aa6963cdea0bd3525@sentry.io/1743118" || '';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_STAGING = "n33vr9vfs09671pc90pgi7kvj8q7vvvfvjvd";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_PRODUCTION = "9a44abjpf5r66aq6r9o6426v9n2tg9ko9tah";
export default environment => {
  switch (environment) {
    case 'TEST':
    case 'LOCAL':
    case 'DEVELOPMENT':
    case 'STAGING':
      return {
        DATACAMP_DOMAIN: 'datacamp-staging.com',
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_STAGING,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          GUACAMOLE_WEBSOCKET_TUNNEL: 'wss://remote-desktop-guacamole.datacamp-staging.com/websocket-tunnel',
          MAIN_APP: 'https://www.datacamp-staging.com',
          MULTIPLEXER_URL: 'https://sessions.datacamp-staging.com',
          PROJECTOR: 'https://projector.datacamp-staging.com',
          PROMETHEUS_AGGREGATOR_URL: 'https://prometheus-aggregator.datacamp-staging.com',
          REMOTE_DESKTOP_API: 'https://tableau-api.datacamp-staging.com',
          TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
        }
      };
    case 'PRODUCTION':
    default:
      return {
        DATACAMP_DOMAIN: 'datacamp.com',
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_PRODUCTION,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp.com',
          GUACAMOLE_WEBSOCKET_TUNNEL: 'wss://remote-desktop-guacamole.datacamp.com/websocket-tunnel',
          MAIN_APP: 'https://www.datacamp.com',
          MULTIPLEXER_URL: 'https://sessions.datacamp.com',
          PROJECTOR: 'https://projector.datacamp.com',
          PROMETHEUS_AGGREGATOR_URL: 'https://prometheus-aggregator.datacamp.com',
          REMOTE_DESKTOP_API: 'https://tableau-api.datacamp.com',
          TEACH_APP: 'https://teach-api.datacamp.com/teach-app'
        }
      };
  }
};